import { render, staticRenderFns } from "./beneficiary-category.vue?vue&type=template&id=73e183ca&"
import script from "./beneficiary-category.vue?vue&type=script&lang=js&"
export * from "./beneficiary-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports